var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.713 8.713C6.90433 8.521 7 8.28333 7 8C7 7.71667 6.904 7.47933 6.712 7.288C6.52 7.09667 6.28267 7.00067 6 7C5.71733 6.99933 5.48 7.09533 5.288 7.288C5.096 7.48067 5 7.718 5 8C5 8.282 5.096 8.51967 5.288 8.713C5.48 8.90633 5.71733 9.002 6 9C6.28267 8.998 6.52033 8.902 6.713 8.712M10.713 8.712C10.9043 8.52133 11 8.284 11 8C11 7.716 10.904 7.47867 10.712 7.288C10.52 7.09733 10.2827 7.00133 10 7C9.71733 6.99867 9.48 7.09467 9.288 7.288C9.096 7.48133 9 7.71867 9 8C9 8.28133 9.096 8.519 9.288 8.713C9.48 8.907 9.71733 9.00267 10 9C10.2827 8.99733 10.5203 8.90133 10.713 8.712ZM14.713 8.712C14.9043 8.52133 15 8.284 15 8C15 7.716 14.904 7.47867 14.712 7.288C14.52 7.09733 14.2827 7.00133 14 7C13.7173 6.99867 13.48 7.09467 13.288 7.288C13.096 7.48133 13 7.71867 13 8C13 8.28133 13.096 8.519 13.288 8.713C13.48 8.907 13.7173 9.00267 14 9C14.2827 8.99733 14.5203 8.90133 14.713 8.712ZM0 20V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H18C18.55 0 19.021 0.196 19.413 0.588C19.805 0.98 20.0007 1.45067 20 2V14C20 14.55 19.8043 15.021 19.413 15.413C19.0217 15.805 18.5507 16.0007 18 16H4L0 20ZM3.15 14H18V2H2V15.125L3.15 14Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7abf8540bba8ba8c0192c60a90c9043f.svg";
export { ForwardRef as ReactComponent };